import ReactTooltip from 'react-tooltip'
import { BILLS_TAGS } from 'app-constants'
import { STATICS } from 'statics'
import { DOWNLOAD_INVOICE_TOOLTIP } from './constants'
import './style.scss'

export function BillsDownload({ tags = [], url = '' }) {
  if (!url) return null

  if (tags.includes(BILLS_TAGS.IN_NEGOTIATION)) return null

  return (
    <a href={url} target='_blank' className='bills-download' rel='noreferrer'>
      <STATICS.DOWNLOAD data-for='download-tip' data-tip={DOWNLOAD_INVOICE_TOOLTIP} />
      <ReactTooltip id='download-tip' />
    </a>
  )
}
